import React from "react";
import { NavLink } from "react-router-dom";
import {
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaPinterestSquare,
} from "react-icons/fa";
import { MdEmail } from "react-icons/md";

export const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="upper-footer">
        <div className="container">
          <div className="row">
            <div className="col col-lg-3 col-md-3 col-sm-6">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <h3>About us</h3>
                </div>
                <p>
                  SVEIL – Sri Venkateswara Engineering and Infrastructure
                  Private Limited is a diversified company engaged in developing
                  sustainable and growth-oriented businesses across multiple
                  sectors.
                </p>
                <div className="social">
                  {/* <ul>
                    <li>
                      <NavLink href="#">
                        <FaFacebook />
                      </NavLink>
                    </li>
                    <li>
                      <NavLink href="#">
                        <FaTwitter />
                      </NavLink>
                    </li>
                    <li>
                      <NavLink href="#">
                        <FaLinkedin />
                      </NavLink>
                    </li>
                    <li>
                      <NavLink href="#">
                        <FaPinterestSquare />
                      </NavLink>
                    </li>
                  </ul> */}
                </div>
              </div>
            </div>
            <div className="col col-lg-3 col-md-3 col-sm-6">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Corporate</h3>
                </div>
                <ul>
                  <li>
                    <NavLink to="/aboutus">About SVEIL </NavLink>
                  </li>
                  <li>
                    <NavLink to="/code-of-conduct">Code of Conduct </NavLink>
                  </li>
                  <li>
                    <NavLink to="/#">Careers </NavLink>
                  </li>
                  <li>
                    <NavLink to="/#">Press Release </NavLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-lg-3 col-md-3 col-sm-6">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Business Units </h3>
                </div>
                <ul>
                  <li>
                    <NavLink to="/#">Aquaculture Division </NavLink>
                  </li>
                  <li>
                    <NavLink to="/#">Poultry Division </NavLink>
                  </li>
                  <li>
                    <NavLink to="/#">Mining Division </NavLink>
                  </li>
                  <li>
                    <NavLink to="/#">
                      Infrastructure & Construction Division{" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/#">
                      Real Estate Development Division{" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/#">Renewable Energy Division </NavLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-lg-3 col-md-3 col-sm-6">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Sectors </h3>
                </div>
                <ul>
                  <li>
                    <NavLink to="/#">Agriculture & Allied </NavLink>
                  </li>
                  <li>
                    <NavLink to="/#">
                      Mining & Natural Resources{" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/#">
                      Infrastructure & Construction{" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/#">Real Estate </NavLink>
                  </li>
                  <li>
                    <NavLink to="/#">Renewable Energy </NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row" style={{marginTop:'30px'}}>
            <div className="col col-lg-3 col-md-3 col-sm-6">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Quick Links</h3>
                </div>
                <ul>
                  <li>
                    <NavLink to="/#">Corporate Profile </NavLink>
                  </li>
                  <li>
                    <NavLink to="/#">Land Mark Projects </NavLink>
                  </li>
                  <li>
                    <NavLink to="/#">
                      CSR (Corporate social responsibility){" "}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/#">Project Gallery </NavLink>
                  </li>
                  <li>
                    <NavLink to="/contact">Contact Us </NavLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-lg-3 col-md-3 col-sm-6">
              <div className="widget contact-widget service-link-widget">
                <div className="widget-title">
                  <h3>Address Location</h3>
                </div>
                <ul>
                  <li>Tadepalli, Guntur, Andhrapradesh - 522501,</li>
                  <li>Sri Venkateswara & Co, Nellore Mndl, Nellore city, Andhra Pradesh - 524003,</li>
                  <li>Phone:+91 9390332035,<br/> +91 9391646324</li>
                  {/* <li>Office Time: 10AM- 7PM</li> */}
                  <li>Email: srivenkateswara148@gmail.com</li>
                </ul>
              </div>
            </div>
            {/* <div className="col col-lg-3 col-md-3 col-sm-6">
              <div className="widget newsletter-widget">
                <div className="widget-title">
                  <h3>Newsletter</h3>
                </div>
                <p>You will be notified when somthing new will be appear.</p>
                <form>
                  <div className="input-1">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email Address *"
                      required
                    />
                  </div>
                  <div className="submit clearfix">
                    <button type="submit">
                      <MdEmail />
                    </button>
                  </div>
                </form>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <div className="lower-footer">
        <div className="container">
          <div className="row">
            <div className="separator"></div>
            <div className="col col-xs-12">
              <p className="copyright">
               Copyright All rights reserved -SVEIL
              </p>
              <div className="short-links">
                {/* <ul>
                  <li>
                    <NavLink href="#">Privacy</NavLink>
                  </li>
                  <li>
                    <NavLink href="#">Terms of Use</NavLink>
                  </li>
                  <li>
                    <NavLink href="#">Cookies</NavLink>
                  </li>
                </ul> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
